export default "__VITE_ASSET__DRXJJH4d__"